"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styled = _interopRequireDefault(require("./styled"));

var _InternalOverlay = _interopRequireDefault(require("../InternalOverlay"));

var _tooltipPositionResolver = _interopRequireDefault(require("./helpers/tooltipPositionResolver"));

var _resolveElement = _interopRequireDefault(require("../InternalOverlay/helpers/resolveElement"));

/**
 * A Tooltip is a small piece of contextual information about an element on the screen, which is displayed when a user hovers or focuses on the element it is describing.
 * @category Internal
 */
var InternalTooltip = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useState = (0, _react.useState)(),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      pos = _useState2[0],
      setPos = _useState2[1];

  var className = props.className,
      style = props.style,
      children = props.children,
      isVisible = props.isVisible,
      preferredPosition = props.preferredPosition,
      triggerElementRef = props.triggerElementRef;
  var tooltipRef = (0, _react.useRef)();

  var handleOpen = function handleOpen() {
    var triggerRect = (0, _resolveElement["default"])(triggerElementRef).getBoundingClientRect();
    var tooltipRect = tooltipRef.current.getBoundingClientRect();

    if (tooltipRect.bottom < triggerRect.top) {
      setPos('top');
    } else if (tooltipRect.top > triggerRect.bottom) {
      setPos('bottom');
    } else if (tooltipRect.right < triggerRect.left) {
      setPos('left');
    } else if (tooltipRect.left > triggerRect.right) {
      setPos('right');
    } else {
      setPos('floating');
    }
  };

  if (!isVisible && pos !== null) {
    setPos(null);
  }

  return /*#__PURE__*/_react["default"].createElement(_InternalOverlay["default"], {
    isVisible: isVisible,
    triggerElementRef: triggerElementRef,
    positionResolver: function positionResolver(opts) {
      return (0, _tooltipPositionResolver["default"])(opts, preferredPosition);
    },
    onOpened: handleOpen,
    keepScrollEnabled: true
  }, /*#__PURE__*/_react["default"].createElement("div", {
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(_styled["default"], {
    role: "tooltip",
    className: className,
    style: style,
    position: pos,
    isVisible: isVisible,
    ref: tooltipRef
  }, children)));
});

InternalTooltip.propTypes = {
  /** A CSS class for the outer element, in addition to the component's base classes. */
  className: _propTypes["default"].string,

  /** An object with custom style applied to the outer element. */
  style: _propTypes["default"].object,

  /** Controls whether the InternalOverlay is visible or not. If true, the content of the Overlay is shown. */
  isVisible: _propTypes["default"].bool,

  /** The preferred position of the tooltip */
  preferredPosition: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right']),

  /** Ref or function that returns a ref to a DOM element, the DOM element resolved by this ref will be used to positioning the component passed when visible. */
  triggerElementRef: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]).isRequired,

  /**
   * @ignore
   */
  children: _propTypes["default"].node
};
InternalTooltip.defaultProps = {
  className: undefined,
  style: undefined,
  isVisible: false,
  preferredPosition: 'top',
  children: undefined
};
var _default = InternalTooltip;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/InternalTooltip/index.js
// module id = cEMR
// module chunks = 0